// @flow
import React from 'react';
import config from 'Config';

import { isExclusiveCollection, isWinter } from 'Components/utils/product/product.utils';
import { ICONS } from 'Components/utils/icon/icons';

import { ProductIntroduction } from 'Components/widgets/product-introduction/ProductIntroduction.jsx';
import { ProductIntroductionExclusiveCollection } from 'Components/widgets/product-introduction-exclusive-collection/ProductIntroductionExclusiveCollection.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

type Props = {|
  communityLabel: string,
  config: CMSContent,
  hasCommunityButton: boolean,
  hasSeasonButton: boolean,
  hasTripadvisorButton: boolean,
  imageSrc: string,
  id: string,
  productCommunity: {
    questions: Array<{ id: string }>,
  },
  resort: Resort,
  toSummerLabel: string,
  toWinterLabel: string,
|};

export function ProductIntroductionLine({
  config: {
    common: { loadLess, viewMore },
    resort: {
      resortIntroduction: { communityLabel, toSummerLabel, toWinterLabel },
    },
  },
  hasCommunityButton,
  hasSeasonButton,
  hasTripadvisorButton,
  id,
  imageSrc,
  productCommunity: { questions },
  resort: {
    comfort,
    descriptionTitle,
    description,
    destination: { country },
    icon,
    images = [],
    isDoubleSeason,
    linkedResort,
    name,
    seasonName,
    tripadvisor: { rating = '', ratingImageUrl = '' },
    type,
  },
}: Props) {
  const props = {
    communityLabel:
      config.get('social.wibilong.enabled') && questions.length && hasCommunityButton
        ? communityLabel
        : '',
    iconName: icon,
    imageSrc: imageSrc || images[2] || images[1] || images[0],
    productCountry: country,
    productName: name,
    ratingImage: hasTripadvisorButton
      ? {
          alt: `Tripadvisor: ${rating}`,
          src: ratingImageUrl,
        }
      : null,
    reduceLabel: loadLess,
    seasonLink:
      isDoubleSeason || !hasSeasonButton
        ? null
        : {
            iconName: isWinter(seasonName) ? ICONS.SUN : ICONS.MOUNTAIN,
            label: isWinter(seasonName) ? toSummerLabel : toWinterLabel,
            url: linkedResort && linkedResort.href,
          },
    seeMoreLabel: viewMore,
    title: descriptionTitle,
    text: description,
  };

  const isEC = isExclusiveCollection(type, comfort);

  return (
    <SiteContainer id={id} className="Line" size={isEC ? 'large' : 'medium'}>
      {isEC ? (
        <ProductIntroductionExclusiveCollection {...props} />
      ) : (
        <ProductIntroduction {...props} />
      )}
    </SiteContainer>
  );
}
